/* 🤖 this file was generated by svg-to-ts */
export const matIconAudioFile: {
  name: 'audio-file';
  data: string;
} = {
  name: 'audio-file',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6zm10-9h-4v3.88a2.247 2.247 0 0 0-3.5 1.87c0 1.24 1.01 2.25 2.25 2.25S13 17.99 13 16.75V13h3v-2z"/></svg>`
};
